/* Two Sense — WhatsApp deep-link helper.
   Centralised so the floating button, header CTA, hero CTA and
   service Reserve button all point at the same chat.

   Greeting copy is sourced from the active i18n locale so the message
   matches the website language. The {{service}} interpolation keeps the
   service name verbatim — only the surrounding sentence is translated. */

import i18n from "../i18n";

export const TS_WA_NUMBER = "601160993326";

const buildLink = (greeting) => {
    const base = `https://wa.me/${TS_WA_NUMBER}`;
    return greeting ? `${base}?text=${encodeURIComponent(greeting)}` : base;
};

/* Only treat the argument as a service name if it's a non-empty string —
   guards against accidental event-object args from `onClick={onBookingClick}`. */
const resolveGreeting = (serviceName) => {
    if (typeof serviceName === "string" && serviceName.trim()) {
        return i18n.t("whatsapp.greetingService", { service: serviceName.trim() });
    }
    return i18n.t("whatsapp.greetingDefault");
};

export const openWhatsApp = (serviceName) => {
    window.open(buildLink(resolveGreeting(serviceName)), "_blank", "noopener,noreferrer");
};

export const whatsAppLink = (serviceName) => buildLink(resolveGreeting(serviceName));

/* Build a chat link from a fully-composed message (e.g. an appointment
   summary). Falls back to the default greeting if no text is supplied. */
export const whatsAppTextLink = (text) =>
    typeof text === "string" && text.trim()
        ? buildLink(text)
        : buildLink(i18n.t("whatsapp.greetingDefault"));
